import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackgroundIllustrations from '../../components/common/BackgroundIllustrations';
import LoginForm from '../../components/patient/LoginForm';
import RegistrationForm from '../../components/patient/RegistrationForm';
import PasswordRecoveryForm from '../../components/patient/PasswordRecovery';
import AuthService from '../../services/auth.service';
import PasswordService from '../../services/password.service';

const PatientAuthPage = () => {
  
  const [error, setError] = useState('');
  const navigate = useNavigate();
   const queryParams = new URLSearchParams(window.location.search);
   const tagId = queryParams.get('tag');
   const [currentForm, setCurrentForm] = useState(tagId ? 'register' : 'login');

  // Funzione per resettare l'errore
  const resetError = () => {
    setError('');
  };

   const handleLogin = async (credentials) => {
    try {
      setError('');
      const response = await AuthService.login(credentials);
      console.log('Login response:', response);

       // Redirect basato sul ruolo
      if (response.user.role === 'admin') {
        alert('Error Account Login');
        return;
      }
      
      // AuthService già gestisce il salvataggio nel localStorage
      // Redirect basato sul ruolo
      if (response.user.role === 'therapist') {
        navigate('/doctor/dashboard');
      } else if (response.user.role === 'patient') {
        navigate(response.has_survey ? '/patient/dashboard' : '/patient/survey');
      }
      
    } catch (error) {
      console.error('Login error:', error);
      setError(error.message || 'Errore durante il login');
    }
  };



  const handlePasswordRecovery = async (email) => {
    console.log("[DEBUG] PatientAuthPage - handlePasswordRecovery ENTER", email);
    try {
      setError('');
      const response = await PasswordService.sendResetLink(email);
      console.log("[DEBUG] PatientAuthPage - Password Recovery Success:", response);
      return response; 
    } catch (error) {
      console.error("[DEBUG] PatientAuthPage - Password Recovery Error:", error);
      setError(error.message || 'Errore durante il recupero password');
      return { success: false };
    }
  };

  const renderForm = () => {
    const props = {
      onSwitchForm: setCurrentForm,
      error: error,
      preselectedTagId: tagId,
      onResetError: resetError, 
      onFieldChange: resetError 
    };

    switch(currentForm) {
      case 'login':
        return <LoginForm {...props} onSubmit={handleLogin} />;
      case 'register':
        return <RegistrationForm {...props}  />;
      case 'recovery':
        return <PasswordRecoveryForm {...props} onSubmit={handlePasswordRecovery} />;
      default:
        return <LoginForm {...props} onSubmit={handleLogin} />;
    }
  };

  return (
    <div className="relative min-h-screen flex flex-col">
      <BackgroundIllustrations className="absolute inset-0 z-0" />
      
      {/* 
        <div className="relative z-10 p-4">
          {error && (
            <div className="max-w-md mx-auto mb-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
              {error}
            </div>
          )}
        </div>
        */}

      
      <div className="flex-grow flex items-center justify-center relative z-10">
        <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
          {renderForm()}
        </div>
      </div>
    </div>
  );
};

export default PatientAuthPage;